import { render } from "./headerWishlist.vue?vue&type=template&id=008ef038&scoped=true"
import script from "./headerWishlist.vue?vue&type=script&lang=js"
export * from "./headerWishlist.vue?vue&type=script&lang=js"

import "./headerWishlist.vue?vue&type=style&index=0&id=008ef038&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008ef038"]])

export default __exports__